import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import { push } from 'connected-react-router'
import { page } from 'utils/trackingUtils'

import * as BillingSelectors from 'modules/billing/selectors'

import Billing from './component'

const mapStateToProps = state => ({
  plan: BillingSelectors.getPlan(state),
  coupon: BillingSelectors.getCoupon(state),
  useNetsuite: BillingSelectors.useNetsuite(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Billing Setup', {
        context: 'widget-onboarding',
      })
    }
  }),
  withHandlers({
    onSkip: props => event => {
      props.actions.push('/setup/touchless/custom')
    },
  }),
)(Billing)
